import * as React from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import MuiCard from '@mui/material/Card';
import FormControl from '@mui/material/FormControl';
import Link from '@mui/material/Link';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import { useLocation, useNavigate } from 'react-router-dom';
import Content from '../content/Content';
import { styled } from '@mui/material/styles';
import { Alert, Divider, FilledInput, Grid, IconButton, InputAdornment, InputLabel, Snackbar } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';

const API = require("../../data/network/API");

function Copyright(props) {
  return (
    <Stack spacing={4} sx={{mt:2}}>
      <Typography variant="body2" color="text.secondary" align="center" {...props}>
      {new Date().getFullYear()} {'© SwitchPoint SA. de CV. All rights reserved'}
      </Typography>
      <Box
          alignSelf= 'center'
          component="img"
          sx={{
            height: 32,
            width: 80,
          }}
          alt="officia logo."
          src="/static/sw.png"
        />
    </Stack>
  );
}

const Card = styled(MuiCard)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignSelf: 'center',
  width: '100%',
  padding: theme.spacing(4),
  backgroundColor: 'transparent',
  gap: theme.spacing(2),
  boxShadow:
    'hsla(220, 30%, 5%, 0.05) 0px 5px 15px 0px, hsla(220, 25%, 10%, 0.05) 0px 15px 35px -5px',
  [theme.breakpoints.up('sm')]: {
    width: '450px',
  },
  ...theme.applyStyles('dark', {
    boxShadow:
      'hsla(220, 30%, 5%, 0.5) 0px 5px 15px 0px, hsla(220, 25%, 10%, 0.08) 0px 15px 35px -5px',
  }),
}));

function RegistryCard() {
  const navigate = useNavigate();
  const {state} = useLocation();

  const [snackbarState, setSnackbarState] = React.useState({open:false,message:"",status:"info"});
  const [showPassword, setShowPassword] = React.useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = React.useState(false);
  const [loader, setLoader] = React.useState(false);

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  }

  const handleMouseUpPassword = (event) => {
    event.preventDefault();
  }

  const handleMouseDownConfirmPassword = (event) => {
    event.preventDefault();
  }

  const handleMouseUpConfirmPassword = (event) => {
    event.preventDefault();
  }

  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const handleClickShowConfirmPassword = () => setShowConfirmPassword((show) => !show);
  
  const handleSubmit = async(event) => {
    event.preventDefault();

    const data = new FormData(event.currentTarget);

    const password = data.get('password')
    const confirm_password = data.get('confirm_password')
    const id_cliente = data.get('id_cliente')

    if(password.length==0){
      setSnackbarState({open:true,message:"Por favor llena todos los campos.",status:"warning"})
      return
    }

    if(confirm_password != password){
        setSnackbarState({open:true, message:"Las contraseñas no coinciden", status:"warning"})
      return
    }

    const requestBody = {
        id_guna: id_cliente,
        id_externo: null,
        correo: state.correo,
        clave_acceso: password,
        estatus: true,
    }

    console.log(requestBody)

    setLoader(true);
    const response = await API.postShopkeeper(requestBody)
    setLoader(false);

    if (response.status == 200){
        console.log(response.data)
        navigate('/registry-profile', {state: {id_usuario: response.data.firestore_id}})
    } else {
      setSnackbarState({open:true, message: response.message, status:"error"})
    }
  };

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbarState({open:false,message:snackbarState.message,status:snackbarState.status})
  };

  return (
    <Card >
        <Box
            alignSelf= 'center'
            component="img"
            sx={{
            height: 56,
            width: 56,
            }}
            alt="officia logo."
            src="/static/logo_guna.png"
        />
       <Box
        alignSelf= 'center'
        component="img"
        sx={{
          height: 256,
          width: 256,
        }}
        alt="officia logo."
        src="/static/sign_in_ background.png"
      />
      <Typography
        component="h5"
        variant="h5"
      >
        Registro
      </Typography>
      <Box component="form" noValidate onSubmit={handleSubmit} sx={{ mt: 1 }}>
        <FormControl fullWidth variant="filled" color='secondary'sx={{mt:2, mb:2}}>
        <InputLabel htmlFor="outlined-adornment-password">Contraseña</InputLabel>
        <FilledInput
          id="password"
          name="password"
          label="Contraseña"
          type={showPassword ? 'text' : 'password'}
          endAdornment={
            <InputAdornment position="end">
              <IconButton
                aria-label="toggle password visibility"
                onClick={handleClickShowPassword}
                onMouseDown={handleMouseDownPassword}
                onMouseUp={handleMouseUpPassword}
                edge="end"
              >
                {showPassword ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </InputAdornment>
          }
        />
        </FormControl>

        <FormControl fullWidth variant="filled" color='secondary'sx={{mt:2, mb:2}}>
        <InputLabel htmlFor="outlined-adornment-password">Confirma tu constraseña</InputLabel>
        <FilledInput
          id="confirm_password"
          name="confirm_password"
          label="Confirma tu contraseña"
          type={showConfirmPassword ? 'text' : 'password'}
          endAdornment={
            <InputAdornment position="end">
              <IconButton
                aria-label="toggle password visibility"
                onClick={handleClickShowConfirmPassword}
                onMouseDown={handleMouseDownConfirmPassword}
                onMouseUp={handleMouseUpConfirmPassword}
                edge="end"
              >
                {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </InputAdornment>
          }
        />
        </FormControl>
        <Divider>¿Eres cliente?</Divider>
        <TextField
          margin="normal"
          required
          fullWidth
          id="id_cliente"
          label="Id cliente"
          name="id_cliente"
          autoComplete="id_cliente"
          variant="filled"
          autoFocus
          color='secondary'
        />
        <Button
          type="submit"
          fullWidth
          variant="contained"
          color='secondary'
          sx={{ mt: 3, mb: 2 }}
        >
          Continuar
        </Button>
        <Grid container>
          <Grid item xs>
            <Stack spacing={2}>
              <Typography variant="body2" color="text.secondary" align="center">
              Al continuar, aceptar nuestras condiciones de uso y venta.
              </Typography>
              <Typography align='center'>
                <Link href="/privacy" variant="body2" color={"secondary"} >
                  Aviso de privicidad
                </Link>
              </Typography>
            </Stack>
          </Grid>
          <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'center' }} open={snackbarState.open} onClose={handleClose}>
            <Alert
              onClose={handleClose}
              severity={snackbarState.status}
              variant="filled"
            >
              {snackbarState.message}
            </Alert>
          </Snackbar>
        </Grid>
        <Copyright/>
      </Box> 
    </Card>
  );
}

export default function Registry() {
  return (
    <>
      <CssBaseline enableColorScheme />
      <Stack
        direction="column"
        component="main"
        sx={[
          {
            justifyContent: 'center',
            height: 'calc((1 - var(--template-frame-height, 0)) * 100%)',
            //marginTop: 'max(40px - var(--template-frame-height, 0px), 0px)',
            minHeight: '100%',
          },
        ]}
      >
        <Stack
          direction={{ xs: 'column-reverse', md: 'row' }}
          sx={{
            justifyContent: 'center',
            gap: { xs: 6, sm: 12 },
            mx: 'auto',
          }}
        >
          <Stack
            direction={{ xs: 'column-reverse', md: 'row' }}
            sx={{
              justifyContent: 'center',
              gap: { xs: 6, sm: 12 },
              p: { xs: 0, sm: 4 },
              m: 'auto',
            }}
          >
            <Content />
            <RegistryCard />
          </Stack>
        </Stack>
      </Stack>
    </>
  );
}